import { useLocation } from "react-router-dom";

import { PhoneNavigateProps } from "~/auth/Validate/Phone";
import { useNamespace } from "~/hooks";

import { Step } from "..";

function StepOne() {
  const { state } = useLocation() as { state: PhoneNavigateProps };
  const { translate } = useNamespace("outdoor");

  return (
    <div className="flex flex-auto w-full max-w-[440px] flex-col gap-4 items-start">
      <h1 className="font-gt text-[18px] md:text-5xl font-bold leading-6 md:leading-[56px] text-center md:text-left text-basic-white-50 md:whitespace-pre-line">
        {translate("outdoor@signUp-step3")}
      </h1>
      {state?.isCreatingAccount && <Step>{translate("outdoor@step-3")}</Step>}
    </div>
  );
}

export default StepOne;
